/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-26 16:04:55
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-06-08 11:19:54
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/common/form.config.js
 */
export default{
    data(){
        return{
            formList:[
                {
                    label:' 可食部 %：',
                    value:'100',
                    name:'ediblePart'
                },
                {
                    label:'水分 g：',
                    value:'',
                    name:'moisture'
                },
                {
                    label:'能量 kcal：',
                    value:'',
                    name:'energyKcal'
                },
                {
                    label:'能量KJ：',
                    value:'',
                    name:'energyKj'
                },
                {
                    label:'蛋白质 g：',
                    value:'',
                    name:'protein'
                },
                {
                    label:'脂肪 g：',
                    value:'',
                    name:'fat'
                },
                {
                    label:'碳水化合物 g：',
                    value:'',
                    name:'carbohydrate'
                },
                {
                    label:'胆固醇 g：',
                    value:'',
                    name:'cholesterol'
                },
                {
                    label:'不溶性膳食纤维 g：',
                    value:'',
                    name:'insolubleDietaryFiber'
                },
                {
                    label:'可溶性膳食纤维 g：',
                    value:'',
                    name:'solubleDietaryFiber'
                },
                {
                    label:'灰分 g：',
                    value:'',
                    name:'ash'
                },
                {
                    label:'总维生素A μgRAE：',
                    value:'',
                    name:'totalVitaminA'
                },
                {
                    label:'胡萝卜素 μg：',
                    value:'',
                    name:'carrot'
                },
                {
                    label:'视黄醇 μg：',
                    value:'',
                    name:'retinol'
                },
                {
                    label:'总维生素E mg：',
                    value:'',
                    name:'totalVitaminE'
                },
                {
                    label:'α-维生素E mg：',
                    value:'',
                    name:'vitaminEa'
                },
                {
                    label:'β+γ-维生素E mg：',
                    value:'',
                    name:'vitaminEb'
                },
                {
                    label:'δ-维生素E mg：',
                    value:'',
                    name:'vitaminEc'
                },
                {
                    label:'维生素D mg：',
                    value:'',
                    name:'vitaminD'
                },
                {
                    label:'维生素K mg：',
                    value:'',
                    name:'vitaminK'
                },
                {
                    label:'维生素C mg：',
                    value:'',
                    name:'vitaminC'
                },
                {
                    label:'烟酸 mg：',
                    value:'',
                    name:'niacin'
                },
                {
                    label:'维生素B1 mg：',
                    value:'',
                    name:'vitaminBOne'
                },
                {
                    label:'维生素B2 mg：',
                    value:'',
                    name:'vitaminBTwo'
                },
                {
                    label:'维生素B6 mg：',
                    value:'',
                    name:'vitaminBSix'
                },
                {
                    label:'维生素B12 mg：',
                    value:'',
                    name:'vitaminBTwelve'
                },
                {
                    label:'叶酸 mg：',
                    value:'',
                    name:'folicAcid'
                },
                {
                    label:'泛酸 mg：',
                    value:'',
                    name:'pantothenicAcid'
                },
                {
                    label:'钙 mg：',
                    value:'',
                    name:'calcium'
                },
                {
                    label:'磷 mg：',
                    value:'',
                    name:'phosphorus'
                },
                {
                    label:'钾 mg：',
                    value:'',
                    name:'potassium'
                },
                {
                    label:'钠 mg：',
                    value:'',
                    name:'sodium'
                },
                {
                    label:'镁 mg：',
                    value:'',
                    name:'magnesium'
                },
                {
                    label:'锌 mg：',
                    value:'',
                    name:'zinc'
                },
                {
                    label:'铁 mg：',
                    value:'',
                    name:'iron'
                },
                {
                    label:'铜 mg：',
                    value:'',
                    name:'copper'
                },
                {
                    label:'硒 mg：',
                    value:'',
                    name:'selenium'
                },
                {
                    label:'锰 mg：',
                    value:'',
                    name:'manganese'
                },
                {
                    label:'碘 mg：',
                    value:'',
                    name:'iodine'
                },
                {
                    label:'氯 mg：',
                    value:'',
                    name:'chlorine'
                },
                {
                    label:'氯化钠 mg：',
                    value:'',
                    name:'sodiumChloride'
                },
                {
                    label:'氯化钾 mg：',
                    value:'',
                    name:'potassiumChloride'
                },
                {
                    label:'天冬氨酸 mg：',
                    value:'',
                    name:'asparticAcid'
                },
                {
                    label:'苏氨酸 mg：',
                    value:'',
                    name:'threonine'
                },
                {
                    label:'丝氨酸 mg：',
                    value:'',
                    name:'serine'
                },
                {
                    label:'谷氨酸 mg：',
                    value:'',
                    name:'glutamicAcid'
                },
                {
                    label:'脯氨酸 mg：',
                    value:'',
                    name:'proline'
                },
                {
                    label:'甘氨酸 mg：',
                    value:'',
                    name:'glycine'
                },
                {
                    label:'丙氨酸 mg：',
                    value:'',
                    name:'alanine'
                },
                {
                    label:'半胱氨酸 mg：',
                    value:'',
                    name:'cysteine'
                },
                {
                    label:'缬氨酸 mg：',
                    value:'',
                    name:'valine'
                },
                {
                    label:'蛋氨酸 mg：',
                    value:'',
                    name:'methionine'
                },
                {
                    label:'异亮氨酸 mg：',
                    value:'',
                    name:'isoleucine'
                },
                {
                    label:'亮氨酸 mg：',
                    value:'',
                    name:'leucine'
                },
                {
                    label:'酪氨酸 mg：',
                    value:'',
                    name:'tyrosine'
                },
                {
                    label:'苯丙氨酸 mg：',
                    value:'',
                    name:'phe'
                },
                {
                    label:'赖氨酸 mg：',
                    value:'',
                    name:'lysine'
                },
                {
                    label:'组氨酸 mg：',
                    value:'',
                    name:'histidine'
                },
                {
                    label:'精氨酸 mg：',
                    value:'',
                    name:'arginine'
                },
                {
                    label:'色氨酸 mg：',
                    value:'',
                    name:'tryptophan'
                },
                {
                    label:'生物素 μg：',
                    value:'',
                    name:'biotin'
                },
                {
                    label:'胆碱 mg：',
                    value:'',
                    name:'choline'
                },
                {
                    label:'嘌呤 mg：',
                    value:'',
                    name:'purine'
                },
                {
                    label:'血糖指数：',
                    value:'',
                    name:'glycemicIndex'
                },
                {
                    label:'未知脂肪 mg：',
                    value:'',
                    name:'unknownFat'
                },
                {
                    label:'脂肪酸 g：',
                    value:'',
                    name:'fattyAcid'
                },
                {
                    label:' 单不饱和脂肪酸比%：',
                    value:'',
                    name:'oneFattyAcid'
                },
                {
                    label:'  多不饱和脂肪酸比%：',
                    value:'',
                    name:'moreFattyAcid'
                },
                {
                    label:'饱和脂肪酸比%：',
                    value:'',
                    name:'saturatedFattyAcid'
                },
                {
                    label:'植物甾醇总量 mg：',
                    value:'',
                    name:'totalPhytosterols'
                },
                {
                    label:'β谷甾醇 mg：',
                    value:'',
                    name:'sitosterol'
                },
                {
                    label:'菜油甾醇 mg：',
                    value:'',
                    name:'campesterol'
                },
                {
                    label:'β谷甾烷醇 mg：',
                    value:'',
                    name:'glutanols'
                },
                {
                    label:'豆甾醇 mg：',
                    value:'',
                    name:'stigmasterol'
                },
                {
                    label:'菜油甾烷醇 mg：',
                    value:'',
                    name:'canolaSteranols'
                },
            ],
            addFoodrules: {
                name: [
                    { required: true, message: '请填写食品名称', trigger: 'blur' },
                ],
                abbreviation: [
                    { required: true, message: '请填写食品简称', trigger: 'blur' },
                ],
                foodBigId: [
                    { required: true, message: '请选择食品大类', trigger: 'change' }
                ],
                foodSmallId: [
                    { required: true, message: '请选择食品小类', trigger: 'change' }
                ],
                status: [
                    { required: true, message: '请选择食品状态', trigger: 'change' }
                ],
                ediblePart:[
                    { required: true, message: '请填写可食部', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 1 到 9 个字符', trigger: 'blur' }
                ]
            }
        }
    }
}
